/**
 * The server's own builds, for host operators.
 *
 * This used to be a tab of Settings, for any administrator. With several organizations on one server
 * the build is shared by all of them, so choosing it belongs to the host: the section is unchanged,
 * only where it lives moved.
 */
import type { Container } from 'webwin';
import { GAP, h1, muted, scrollPage, stackOf, vstack } from '../ui/layout.js';
import type { CrmPage, PageContext } from './page.js';
import { serverUpdateSection } from './sections/server-updates.js';

export function serverUpdatesPage(): CrmPage {
  return {
    mount(host: Container, ctx: PageContext) {
      const section = serverUpdateSection(ctx);
      const { view, content } = scrollPage();
      content.controls.add(
        stackOf(
          vstack({ spacing: GAP.lg }),
          stackOf(
            vstack({ spacing: GAP.xs }),
            h1('Server updates'),
            muted('The build this server runs. Every organization on the server runs it, so it is changed here rather than in any one of them.')
          ),
          section.card
        )
      );
      host.controls.add(view);
      void section.load();
    }
  };
}
